import { CellWithTooltip } from "@/components/data-table/CellWithTooltip";
import { ColumnHeader } from "@/components/data-table/ColumnHeader";
import { TypographyInlineCode } from "@/components/typography/InlineCode";
import { createColumnHelper } from "@tanstack/react-table";
import { format } from "date-fns";
import { InvitationAction } from "./InvitationAction";

export type InvitationsTable = {
  email: string;
  role: string;
  invited: Date;
  id: string;
};

const columnHelper = createColumnHelper<InvitationsTable>();

export const invitationsColumns = [
  columnHelper.accessor("email", {
    cell: ({ cell }) => <CellWithTooltip cellValue={cell.getValue()} />,
    header: ({ column }) => <ColumnHeader column={column} title="Email" />
  }),
  columnHelper.accessor("role", {
    cell: (info) => (
      <TypographyInlineCode>
        {info.getValue().toLowerCase()}
      </TypographyInlineCode>
    ),
    header: ({ column }) => <ColumnHeader column={column} title="Role" />
  }),
  columnHelper.accessor("invited", {
    cell: ({ cell }) => <span>{format(cell.getValue(), "PP")}</span>,
    header: ({ column }) => <ColumnHeader column={column} title="Invited" />
  }),
  columnHelper.display({
    id: "memberAction",
    cell({ row }) {
      return <InvitationAction invitationId={row.original.id} />;
    }
  })
];
